<div class="absolute inset-0 pointer-events-none overflow-hidden z-0 opacity-10">
  @for (line of lines; track $index) {
    <div
      class="absolute bg-white/80 h-[1px] w-full"
      [style.top]="line.top"
      [style.animation-name]="line.animationName"
      [style.animation-duration]="line.animationDuration"
      [style.animation-iteration-count]="'infinite'"
      [style.animation-timing-function]="'linear'"
    ></div>
  }
</div>
